// libs
import { styled } from '@nykaa/ui-components';

// animations
import shakeCss from 'shared/styles/animations/shake';

// constants
import { BREAKPOINTS, HIDE_SCROLLBARS } from 'shared/styles/base';

export const SizeOptionContainer = styled.div<{ shake?: boolean }>`
  margin: ${({ theme }) => `${theme.spacing.spacing60} 0 ${theme.spacing.spacing80} 0`};
  width: 100vw;
  ${({ theme }) => theme.typography.bodySmall};
  ${({ shake = false }) => shake && shakeCss}
`;

export const BodyMeasContainer = styled.div`
  margin: ${({ theme }) => theme.spacing.spacing40} 0;
  @media (min-width: ${BREAKPOINTS.TABLET}px) and (max-width: ${BREAKPOINTS.DESKTOP}px) {
    text-align: center;
  }
`;

export const BodyMeasTitle = styled.div`
  ${({ theme }) => theme.typography.subTitleSmall};
  color: ${({ theme }) => theme.colors.textPrimary};
  margin-bottom: ${({ theme }) => theme.spacing.spacing20};
  text-transform: capitalize;
`;

export const BodyPart = styled.span`
  &:after {
    content: '|';
    padding: ${({ theme }) => `0 ${theme.spacing.spacing50}`};
    ${({ theme }) => theme.typography.bodyXSmall};
  }
  @media (max-width: ${BREAKPOINTS.DESKTOP}px) {
    &:last-child {
      &:after {
        display: none;
      }
    }
  }
`;

export const SizeGuideButton = styled.button`
  ${({ theme }) => theme.typography.subTitleLarge};
  color: ${({ theme }) => theme.colors.salmon500};
  background: none;
  border: none;
  outline: none;
  text-decoration: underline;
  cursor: pointer;
  display: inline;
  text-decoration: none;
  margin-left: ${({ theme }) => theme.spacing.spacing80};
  @media (max-width: ${BREAKPOINTS.DESKTOP}px) {
    float: right;
    padding: 0;
    ${({ theme }) => theme.typography.subTitleMedium};
  }
`;

export const SizeBtnContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  min-width: 100vw;
  align-items: start;
  margin-left: ${({ theme }) => `-${theme.spacing.spacing100}`};
  margin-right: ${({ theme }) => `-${theme.spacing.spacing100}`};
  &&:last-of-type {
    padding-right: ${({ theme }) => theme.spacing.spacing100};
  }
  &&:first-of-type {
    padding-left: ${({ theme }) => theme.spacing.spacing100};
  }
  @media (min-width: ${BREAKPOINTS.TABLET}px) and (max-width: ${BREAKPOINTS.DESKTOP}px) {
    justify-content: center;
  }
  @media (max-width: ${BREAKPOINTS.MOBILE}px) {
    flex-wrap: unset;
    flex-flow: row;
    width: 100%;
    overflow-y: scroll;
    ${HIDE_SCROLLBARS};
  }
`;
